module.exports = __webpack_public_path__ + "static/media/downArrow-black.389ca4e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/downArrow-black.svg
// module id = 105
// module chunks = 0